import React, { useState, useEffect } from 'react';
import { Select, message, Space, Typography } from 'antd'
import axios from "axios"
import moment from "moment"

const { Option } = Select
const { Text } = Typography 

/**
 * @const SelectFactura
 * @description Select para las facturas registradas en el sistema
 */
const SelectFactura = (props) => {

    const { 
        value, 
        onChange = () => {}, 
        placeholder = "Seleccione la factura", 
        onSelect = () => {}, 
        onDeselect = () => {},
        disabled = false, 
        className = "", 
        params = {}, 
        bordered, 
        allowClear = true, 
        onClear = () => {},
        labelInValue = false,
        mode = "multiple",
        returnID = false,
    } = props

    const [ facturas, setFacturas ] = useState({
        itemsList: [],
        currentPage: 1,
        limit: 50,
        total: 0,
        search: null,
    })


    /**
     * @const getFacturas
     * @description Obtiene las facturas
     */
    const getFacturas = ({
        currentPage, 
        limit, 
        search, 
    } = facturas) => {

        axios.get('/facturas/list-v2', {
            params: {
                page: currentPage,
                limit,
                search,
                ...params,
            },
            headers: { Authorization: sessionStorage.getItem('token') }
        }).then(({ data }) => {
            console.log('facturas data', data);
            setFacturas({
                itemsList: data.data || [],
                currentPage: data.page || 1,
                limit: data.limit || 100,
                total: data.total || 0,
                search
            })
        }).catch(error => {
            console.log("ERR, error", error)
            message.error(error?.response?.data?.message ?? 'Error al obtener las facturas')
        })
    }

    //componentDidMount
    useEffect(() => {
        getFacturas()
    }, [])

    /**
     * @description Renderiza la información de la factura
     */
    const renderFactura = ({ concepto, serie, folio, uuid, monto, createdAt }) => (
        <Space direction="vertical" className="width-100">
            <Space className="width-100" style={{ justifyContent: "space-between" }}>
                <Text strong>{concepto} <small>{serie}-{folio}</small> <i><small> ({moment(createdAt).format("YY/MM/DD")})</small></i></Text>
                <Text>{(monto ?? 0).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}</Text>
            </Space>
            <Text italic>{uuid}</Text>
        </Space>
    )

    return (
        <Select
            bordered={bordered}
            className={className}
            disabled={disabled}
            placeholder={placeholder}
            allowClear={allowClear}
            showSearch
            filterOption={false}
            labelInValue={labelInValue}
            mode={mode}
            onSearch={(search) => getFacturas({ search })}
            onSelect={(factura, option) => {
                if (mode === "multiple") {
                    // En modo múltiple, onChange recibe el array completo
                    onSelect(option.factura._id, option.factura)
                } else {
                    const data = {
                        uuid: factura.value || factura,
                        ...option.factura
                    }
                    if (!labelInValue) {
                        onChange(factura.value || factura)
                        onSelect(option.factura._id, data)
                    } else {
                        onChange(factura)
                        onSelect(option.factura._id, data)
                    }
                }
            }}
            onDeselect={(value) => {
                const factura = returnID 
                    ? facturas.itemsList.find(f => f._id === value)
                    : facturas.itemsList.find(f => f.uuid === value);
                onDeselect(factura?._id, factura)
            }}
            onChange={(values) => {
                if (mode === "multiple") {
                    onChange(values)
                } else {
                    onChange(values)
                }
            }}
            value={value}
            onClear={() => {
                onClear()
                onChange(mode === "multiple" ? [] : undefined)
                onSelect(undefined)
            }}
        >
            {
                facturas?.itemsList?.map((factura) => 
                    <Option 
                        value={returnID ? factura._id : factura.uuid} 
                        key={factura.uuid || factura._id} 
                        factura={factura}
                    >
                        {renderFactura(factura)}
                    </Option>
                )
            }
        </Select>
    );
}



export default SelectFactura;
